import Flicking from '@egjs/react-flicking'
import React from 'react'
import Card from '../organisms/Card'

const M10Cards = ({ heading, variant, cards, background, anchorLinkId }) => {
  return (
    <section
      className={`my-5 py-5 overflow-hidden md:py-10 md:my-10 ${
        background === 'white' && 'bg-white'
      }`}
      id={anchorLinkId}
    >
      <div className="container">
        <h2 className="max-w-4xl u-h1 mb-11">{heading}</h2>

        <div className="px-5 py-10 space-x-6 sm:px-7 md:px-8 lg:px-10">
          <Flicking
            autoInit
            align={'prev'}
            renderOnlyVisible={false}
            bound={true}
          >
            {cards.map(card => (
              <div key={card.id} className="pr-6">
                <Card card={card.card[0]} variant={variant} />
              </div>
            ))}
          </Flicking>
        </div>
      </div>
    </section>
  )
}

export default M10Cards
